import { Controller } from "@hotwired/stimulus"

// Drives the duplicate-review drawer's target section. Any change to the target
// mode, date, offset or global employee refetches the review as a Turbo Stream so
// the per-row "source → target" previews stay server-rendered. The current
// checkbox deselection travels along so refetches don't reset it, and the per-row
// edit link is built from the live form state for the same reason.
//
// Usage: data-controller="duplicate-target"
//        data-duplicate-target-url-value="/configurable_time_sheets/duplicate_review"
//        data-duplicate-target-edit-url-value="/configurable_time_sheets/edit_duplicate_entry"
export default class extends Controller {
  static targets = ["absolutePane", "offsetPane", "rangePane"]
  static values = { url: String, editUrl: String }

  disconnect() {
    clearTimeout(this.debounceTimer)
  }

  modeChanged(event) {
    const mode = event.target.value
    if (this.hasAbsolutePaneTarget)
      this.absolutePaneTarget.classList.toggle("hidden", mode !== "absolute")
    if (this.hasOffsetPaneTarget)
      this.offsetPaneTarget.classList.toggle("hidden", mode !== "offset")
    if (this.hasRangePaneTarget) this.rangePaneTarget.classList.toggle("hidden", mode !== "range")
    this.refresh()
  }

  refresh() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => {
      this.fetchStream(`${this.urlValue}?${this.currentParams()}`)
    }, 300)
  }

  editEntry(event) {
    event.preventDefault()
    const sourceId = event.currentTarget.dataset.sourceId
    const params = this.currentParams()
    params.set("source_id", sourceId)
    this.fetchStream(`${this.editUrlValue}?${params}`)
  }

  fetchStream(url) {
    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
      },
    })
      .then((response) => response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html)
      })
      .catch((error) => {
        console.error("Failed to reload duplicate review:", error)
      })
  }

  currentParams() {
    const params = new URLSearchParams()
    const mode = this.element.querySelector('input[name="target_mode"]:checked')?.value
    if (mode) params.set("target_mode", mode)
    const date = this.element.querySelector('input[name="target_date"]')?.value
    if (date) params.set("target_date", date)
    const offset = this.element.querySelector('input[name="offset_days"]')?.value
    if (offset) params.set("offset_days", offset)
    const globalEmployee = this.element.querySelector('select[name="global_employee_id"]')?.value
    if (globalEmployee) params.set("global_employee_id", globalEmployee)
    const rangeFrom = this.element.querySelector('input[name="range_from"]')?.value
    if (rangeFrom) params.set("range_from", rangeFrom)
    const rangeTo = this.element.querySelector('input[name="range_to"]')?.value
    if (rangeTo) params.set("range_to", rangeTo)
    this.element
      .querySelectorAll('input[type="checkbox"][name^="skip_"]')
      .forEach((checkbox) => params.set(checkbox.name, checkbox.checked ? "1" : "0"))
    this.element
      .querySelectorAll('input[name="source_timesheet_ids[]"]:not(:checked)')
      .forEach((checkbox) => params.append("deselected_ids[]", checkbox.value))
    return params
  }
}
